module.exports = __webpack_public_path__ + "img/item1.a0c26797.png";